import { render, staticRenderFns } from "./ApplicantInfo.vue?vue&type=template&id=585ea1d5&scoped=true&"
import script from "./ApplicantInfo.vue?vue&type=script&lang=js&"
export * from "./ApplicantInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585ea1d5",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VAlert,VCard,VCardText,VCardTitle,VIcon,VList,VListItem,VListItemContent,VListItemIcon,VListItemTitle})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('585ea1d5')) {
      api.createRecord('585ea1d5', component.options)
    } else {
      api.reload('585ea1d5', component.options)
    }
    module.hot.accept("./ApplicantInfo.vue?vue&type=template&id=585ea1d5&scoped=true&", function () {
      api.rerender('585ea1d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/application/components/Application/Setup/ApplicantInfo.vue"
export default component.exports